import React from 'react';
import { Route } from 'react-router-dom';
import MainLayout from 'app/components/layouts/MainLayout';
import BorrowingLayout from 'app/components/borrowing/shared/BorrowingLayout';
import AuthenticatedRoute from 'app/routes/AuthenticatedRoute';
import AccountRequiredRoute from 'app/routes/AccountRequiredRoute';
import CheckedOutPageRoute from './CheckedOutPageRoute';

const basePath = '/v2/checkedout';

export default (
  <Route path={`${basePath}/:status?`}>
    <AuthenticatedRoute>
      <AccountRequiredRoute>
        <MainLayout deprecated>
          <BorrowingLayout>
            <CheckedOutPageRoute />
          </BorrowingLayout>
        </MainLayout>
      </AccountRequiredRoute>
    </AuthenticatedRoute>
  </Route>
);
